import React from 'react';
import { useIntl } from 'react-intl';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useCore } from 'contexts/core';
import { isMobile } from 'utils/platform';
import Box from 'ui/Box';
import Body from 'ui/Typography/Body';
import { getAllowedHandleTypes } from '../utils/frontLayouts';
import SkapaInlineMessage, { InlineMessageVariantEnum } from 'ui/InlineMessage/SkapaInlineMessage';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';

const IntegratedHandleWidget = () => {
  const coreApi = useCore();
  const { formatMessage } = useIntl();

  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity || getAllowedHandleTypes(selectedEntity).length > 0) {
    return null;
  }

  return (
    <Box mt="l" mb="l">
      {!isMobile() && (
        <Body
          mb="md"
          fontWeight="bold"
          data-testid="integrated-handle-widget"
          type={ThemeFontStyleTypeEnum.bodyMedium}
        >
          {formatMessage({ id: 'storageone.productListHandlesTitle' })}
        </Body>
      )}
      <SkapaInlineMessage
        body={formatMessage({ id: 'storageone.integratedHandlesInfoMessageSelectedFront' })}
        variant={InlineMessageVariantEnum.INFORMATIVE}
        ssrIcon={InformationCircle}
        subtle
      />
    </Box>
  );
};

export default IntegratedHandleWidget;
